var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 10,
    fill: "#FFFBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11329 8.24138V7.64062C7.11329 6.00966 8.43544 4.6875 10.0664 4.6875C11.6974 4.6875 13.0195 6.00966 13.0195 7.64062V8.24138C13.7873 8.57647 14.284 9.33414 14.2852 10.1719V12.7031C14.2838 13.8675 13.3402 14.8111 12.1758 14.8125H7.95705C6.79266 14.8111 5.84907 13.8675 5.84767 12.7031V10.1719C5.84876 9.33414 6.3455 8.57647 7.11329 8.24138ZM9.64454 11.8594C9.64454 12.0924 9.83342 12.2812 10.0664 12.2812C10.2994 12.2812 10.4883 12.0924 10.4883 11.8594V11.0156C10.4883 10.7826 10.2994 10.5938 10.0664 10.5938C9.83342 10.5938 9.64454 10.7826 9.64454 11.0156V11.8594ZM7.95703 8.06251H12.1758V7.64064C12.1758 6.47567 11.2314 5.53126 10.0664 5.53126C8.90143 5.53126 7.95703 6.47565 7.95703 7.64064V8.06251Z",
    fill: "#FFB531"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLock);
export default __webpack_public_path__ + "static/media/notification_lock.688e5a012813658ca20f19a1a557b6d7.svg";
export { ForwardRef as ReactComponent };